<template>
  <div :class="$style.formatDetail">
    <div :class="$style.header">
      <BasePicture
        v-if="data?.icon"
        :img-class="$style.icon"
        :src="data?.icon"
        alt=""
        aria-hidden="true"
      />
      <BaseHeading size="h5" :class="$style.heading">
        {{ data?.heading }}
      </BaseHeading>
    </div>
    <MarkedParser :class="$style.copy" :md="data?.copy" />
  </div>
</template>

<script setup lang="ts">
defineProps<{
  data: {
    icon: string
    heading: string
    copy: string
  }
}>()
</script>

<style lang="scss" module>
.formatDetail {
  background-color: var(--white);
  color: var(--gray-8);
  font-size: to-rem(17px);
  line-height: math.div(27, 17);
  padding: 30px 40px;
}

.header {
  align-items: center;
  display: flex;
  margin-bottom: 12px;
}

.icon {
  height: 35px;
  margin-right: 12px;
  width: 35px;
}

.heading {
  color: var(--black);
}
</style>
